export default __webpack_public_path__ + "static/media/quarter-circle.97e9293d.webp";